import { kebabCase } from 'lodash'
import { PolygonStyle, styleFromPolygonType, strokeWidth } from './MapHelpers'

export class MapLegendItem {
  constructor (label, style) {
    this.label = label
    this.style = { border: null, color: null }
    this.style.border = style.border
    this.style.color = style.color

    const DIMENSION = 16
    this.style.width = `${DIMENSION}px`
    this.style.height = `${DIMENSION}px`
    this.style.borderRadius = `${strokeWidth}px`
    this.style.backgroundColor = this.style.color

    this.hidden = false
  }

  set color (color) {
    this.style.color = color
    this.style.backgroundColor = color
  }

  set border (border) { this.style.border = border }

  get elementId () { return `legend-${kebabCase(this.label)}` }
}

export class MapLegend {
  constructor () {
    this.viewingCut = false
    this.viewingParcel = false
    this.viewingPickupRadius = false
    this.createCut()
    this.createParcel()
    this.createPickupRadius()
  }

  createCut () { this.Cut = new MapLegendItem(PolygonStyle.Cut.legendLabel, styleFromPolygonType(PolygonStyle.Cut)) }
  createParcel () { this.Parcels = new MapLegendItem(PolygonStyle.Parcels.legendLabel, styleFromPolygonType(PolygonStyle.Parcels)) }
  createPickupRadius () { this.PickupRadius = new MapLegendItem(PolygonStyle.PickupRadius.legendLabel, styleFromPolygonType(PolygonStyle.PickupRadius)) }

  get content () {
    return [
      this.viewingParcel ? this.Parcels : undefined,
      this.viewingPickupRadius ? this.PickupRadius : undefined,
      this.viewingCut ? this.Cut : undefined
    ].filter(i => i)
  }

  get containerStyle () {
    const length = this.content?.length
    if (length < 1) return { display: 'none' }
    const STANDARD_PADDING = 8
    const px = (value) => `${value}px`
    const SOFT_BLACK = 'rgba(34, 34, 34, 0.867)'
    const width = `${132 * length}px`
    const bottom = px(STANDARD_PADDING)
    const left = px(STANDARD_PADDING)
    return {
      position: 'absolute',
      bottom,
      left,
      zIndex: 1,
      border: 'none',
      width,
      transition: '.1s',
      overflow: 'hidden',
      height: '32px',
      display: 'flex',
      backgroundColor: SOFT_BLACK
    }
  }
}

export function getLegendInstance () {
  return new MapLegend()
}
